var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"jns","toolbar":"","footer":""}},[(_vm.displayMenu)?_c('JNSMenu'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('modal-helpers'),_vm._v(" "),(_vm.displayFullBlockAlert)?_c('form-alert-full-block'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25300a24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = +igq
// module chunks = 0